import type { ReactNode } from 'react';
import { EarlyDevConsole } from './EarlyDevConsole';

type LoadingScreenProps = {
  title?: ReactNode;
  message?: ReactNode;
  details?: ReactNode;
  actions?: ReactNode;
  showDevConsole?: boolean;
};

export function LoadingScreen({
  title = 'Loading...',
  message = 'Checking session status.',
  details,
  actions,
  showDevConsole = true,
}: LoadingScreenProps) {
  console.log('[LoadingScreen] Rendering with:', { title, message, showDevConsole });

  return (
    <>
      <div
        data-component="LoadingScreen"
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
          fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          color: '#1f2937',
          backgroundColor: '#f3f4f6',
          padding: '20px',
        }}
      >
        <div
          style={{
            width: '28px',
            height: '28px',
            borderRadius: '50%',
            border: '3px solid #e5e7eb',
            borderTopColor: '#6366f1',
            animation: 'shared-ui-spin 0.8s linear infinite',
          }}
        />
        <div style={{ fontWeight: 600 }}>{title}</div>
        <div style={{ fontSize: '14px', color: '#6b7280' }}>{message}</div>
        {actions ? <div>{actions}</div> : null}
        {details ? (
          <details style={{ marginTop: '8px', fontSize: '12px', color: '#4b5563' }}>
            <summary style={{ cursor: 'pointer' }}>Debug details</summary>
            <div style={{ marginTop: '6px' }}>{details}</div>
          </details>
        ) : null}
        <style>
          {`
            @keyframes shared-ui-spin {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
      {showDevConsole ? <EarlyDevConsole /> : null}
    </>
  );
}
